import { createContext, useContext, useEffect } from "react";

// Pages opt into pull-to-refresh by registering a refresh handler. Layout owns the scroll
// container and the pull gesture; this context wires a page's loader to it.
export const RefreshContext = createContext(() => {});

export function usePageRefresh(onRefresh) {
  const register = useContext(RefreshContext);
  useEffect(() => {
    register(onRefresh);
    return () => register(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
